import React, { useEffect, useState } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { Button } from "./ui/button";

export default function BarcodeScannerModal({ isOpen, onClose, onDetected }) {
  const [permissionError, setPermissionError] = useState("");

  useEffect(() => {
    if (!isOpen) setPermissionError("");
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-4">
      <div className="w-full max-w-md rounded-2xl bg-gray-950 text-white shadow-2xl overflow-hidden border border-white/10">
        <div className="p-4 flex items-center justify-between">
          <h3 className="font-bold text-lg">مسح باركود الجواز</h3>
          <Button variant="ghost" onClick={onClose} className="text-white">
            إغلاق
          </Button>
        </div>

        <div className="px-4 pb-4">
          <div className="rounded-xl overflow-hidden border border-white/10 bg-black">
            <BarcodeScannerComponent
              width={"100%"}
              height={320}
              // حاول الكاميرا الخلفية
              constraints={{ facingMode: "environment" }}
              onUpdate={(err, result) => {
                if (err?.name === "NotAllowedError") {
                  setPermissionError("تم رفض إذن الكاميرا. فعّل الإذن من المتصفح.");
                }
                if (result?.text) {
                  onDetected(result.text);
                  onClose();
                }
              }}
            />
          </div>

          <p className="text-xs text-gray-300 mt-3 text-right" dir="rtl">
            وجّه الكاميرا على الباركود/QR وسيتم إدخال الرقم تلقائيًا.
          </p>

          {permissionError ? (
            <p className="text-xs text-red-300 mt-2 text-right" dir="rtl">
              {permissionError}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
